import { getZ3KHeatingCircuitsConfig } from 'console/shared/content/device/heating-circuits/z3k';
import { getClimaticHeatingCircuitsConfig } from 'console/shared/content/device/heating-circuits/z3k/climatic';
import { select_boiler_modes, select_consumer_modes } from 'z3k-parser/lib/z3k-selectors';
import { getZ3KHeatingModesConfig } from 'console/shared/content/device/heating-modes/z3k';
import { getClimaticHeatingModesConfig } from 'console/shared/content/device/heating-modes/z3k/climatic';
import { getZ3KBoilerHeatingCircuitsConfig } from 'console/shared/content/device/heating-circuits/z3k/boiler';
import { getClimaticBoilerHeatingCircuitsConfig } from 'console/shared/content/device/heating-circuits/z3k/climatic-boiler';
import { getZ3KCustomControlsConfig } from 'console/shared/content/device/custom-controls/z3k';
import { getZ3KThermometersConfig } from 'console/shared/content/device/thermometers/z3k';
import { getClimaticThermometersConfig } from 'console/shared/content/device/thermometers/z3k/climatic';
import { getZ3KSensorsConfig } from 'console/shared/content/device/sensors/z3k';
import { getClimaticSensorsConfig } from 'console/shared/content/device/sensors/z3k/climatic';
import { useMemo } from 'react';
import { getTabConfig } from 'console/shared/contexts/utils';
import { getDeviceShownEntities } from '../../../utils';
export const useZ3KHeatingCircuitsConfig = (device_id, z3k_config, is_climatic, show_hidden) => {
    const z3k_heating_circuits = getZ3KHeatingCircuitsConfig(device_id, z3k_config, show_hidden);
    if (is_climatic) {
        return getClimaticHeatingCircuitsConfig(z3k_heating_circuits);
    }
    return z3k_heating_circuits;
};
export const useZ3KHeatingModesConfig = (device_id, z3k_config, is_climatic, show_hidden = false) => {
    const heating_modes = getZ3KHeatingModesConfig(device_id, select_consumer_modes(z3k_config), show_hidden);
    const boiler_heating_modes = getZ3KHeatingModesConfig(device_id, select_boiler_modes(z3k_config), show_hidden);
    if (is_climatic) {
        return {
            heating_modes: getClimaticHeatingModesConfig(device_id, z3k_config),
            boiler_heating_modes: [],
        };
    }
    return { heating_modes, boiler_heating_modes };
};
export const useZ3KBoilerHeatingCircuitsConfig = (z3k_config, is_climatic, show_hidden = false) => {
    const z3k_boiler_heating_circuits = getZ3KBoilerHeatingCircuitsConfig(z3k_config, show_hidden);
    if (is_climatic) {
        return getClimaticBoilerHeatingCircuitsConfig(z3k_boiler_heating_circuits);
    }
    return z3k_boiler_heating_circuits;
};
export const useZ3KCustomControlsConfig = (device_id, z3k_config, show_hidden) => {
    const custom_controls_config = getZ3KCustomControlsConfig(device_id, z3k_config, show_hidden);
    return custom_controls_config;
};
export const useZ3KThermometersConfig = (z3k_config, is_climatic) => {
    const z3k_thermometers = getZ3KThermometersConfig(z3k_config);
    if (is_climatic) {
        return getClimaticThermometersConfig(z3k_config, z3k_thermometers);
    }
    return z3k_thermometers;
};
export const useZ3KSensorsConfig = (z3k_config, is_climatic) => {
    const z3k_sensors = getZ3KSensorsConfig(z3k_config);
    if (is_climatic) {
        return getClimaticSensorsConfig(z3k_sensors);
    }
    return z3k_sensors;
};
export const useZ3KEntitiesConfig = (config, custom_config_ids) => {
    const entities_config = useMemo(() => {
        const tab_config = getTabConfig(config);
        if (custom_config_ids) {
            return getDeviceShownEntities(tab_config, custom_config_ids);
        }
        return tab_config;
    }, [config, custom_config_ids]);
    return entities_config;
};
